import React from "react";


export const Dot = () => (
    <svg className="text-gray-600 mx-1" style={{display: "inline-block", marginTop: "-2px"}}
         width={6} height={6}
         viewBox="0 0 6 6" xmlns="http://www.w3.org/2000/svg"
    >
        <circle display="inline" cx="3" cy="3" r="3" fill="currentColor"/>
    </svg>
);
export const Miles = ({miles}: { miles: number | undefined }) => !miles ? null : (<>
    <Dot/>
    <span>{miles} mi</span>
</>);
